// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getNestedValue } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var GridCellValueVue2 = {
  name: 'GridCellValue',
  props: {
    dataItem: Object,
    column: Object,
    editField: String,
    editCell: Object,
    inbuildCell: Object
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var inEdit = this.editField ? getNestedValue(this.editField, this.dataItem) : false;
    return this.column.editable && this.editField && (inEdit === true || inEdit === this.column.field) ? this.editCell : this.inbuildCell;
  }
};
/**
 * @hidden
 */
var GridCellValue = GridCellValueVue2;
export { GridCellValue, GridCellValueVue2 };